import { InflowOutflowByMonth } from 'services/requests';
import { formatMonthAndYear, formatUSD } from 'utils';
import { CustomColumn } from 'components/Table/Table.types';

import styles from './EtzProfileInflowOutflowTable.module.css';

export type EtzInflowOutflowTableSign = Omit<
  InflowOutflowByMonth,
  'month' | 'year' | 'deposits' | 'withdrawals'
> & {
  monthAndYear: string;
  deposits: string;
  withdrawals: string;
};

export type MapData = EtzInflowOutflowTableSign[];

export const mapData = (data: InflowOutflowByMonth[] | undefined): MapData | undefined =>
  data?.map((inflowOutflowByMonth: InflowOutflowByMonth) => ({
    ...inflowOutflowByMonth,
    monthAndYear: formatMonthAndYear(
      inflowOutflowByMonth.month,
      inflowOutflowByMonth.year,
    ),
    deposits: formatUSD(inflowOutflowByMonth.deposits),
    withdrawals: formatUSD(inflowOutflowByMonth.withdrawals),
  }));

type Columns = CustomColumn<EtzInflowOutflowTableSign>[];

export const columns: Columns = [
  {
    Header: 'Month, year',
    accessor: 'monthAndYear',
    className: styles.monthYearColumn,
  },
  {
    Header: 'Inflow',
    accessor: 'deposits',
    className: styles.deposits,
  },
  {
    Header: 'Outflow',
    accessor: 'withdrawals',
    className: styles.withdrawals,
  },
];
